import { t } from 'i18next';
import React from 'react';
import IndexRoute from 'react-router/lib/IndexRoute';
import Route from 'react-router/lib/Route';
import * as hooks from '../auth/routerHooks';
import withNewDesignStyles from '../common/hoc/withNewDesignStyles';
import {
  ExternalBrandMemberships,
  ExternalBrandMembershipsHeader,
  ExternalShopMemberships,
  ExternalShopMembershipsHeader,
} from './externalMemberships';
import InvoicesList from './invoices/InvoicesList';
import Layout from './Layout';
import MembershipShops from './memberships/MembershipShops';
import Memberships from './memberships/MembershipsList';
import ImportSubscriptions from './subscriptions/ImportSubscriptionsForm';
import SubscriptionsList from './subscriptions/SubscriptionsList';

const ShopRoutes = (store) => (
  <Route
    path="memberships"
    component={withNewDesignStyles(Layout)}
    onEnter={hooks.requireShopAccessToMemberships(store)}
  >
    <IndexRoute
      components={{ title: () => <span>{t('memberships:navigation.memberships')}</span>, children: Memberships }}
    />

    <Route
      path="subscriptions"
      components={{
        title: () => <span>{t('memberships:navigation.subscriptions')}</span>,
        children: SubscriptionsList,
      }}
    />
    <Route
      path="invoices"
      components={{ title: () => <span>{t('memberships:navigation.invoices')}</span>, children: InvoicesList }}
    />
    <Route
      path="add"
      components={{
        title: () => <span>{t('memberships:navigation.memberships')}</span>,
        heading: () => <span>{t('memberships:navigation.add_membership')}</span>,
        children: ExternalShopMemberships,
        headerButtons: () => <ExternalShopMembershipsHeader />,
        hideNavigation: true,
      }}
    />
    <Route
      path=":id/edit"
      components={{
        title: () => <span>{t('memberships:navigation.memberships')}</span>,
        heading: () => <span>{t('memberships:navigation.edit_membership')}</span>,
        children: ExternalShopMemberships,
        headerButtons: () => <ExternalShopMembershipsHeader />,
        hideNavigation: true,
      }}
    />
    <Route
      path="import"
      components={{
        title: () => <span>{t('memberships:navigation.memberships')}</span>,
        heading: () => <span>{t('memberships:navigation.import_member_subscriptions')}</span>,
        children: ImportSubscriptions,
      }}
    />
  </Route>
);

const BrandRoutes = (store) => (
  <Route
    path="memberships"
    name="memberships"
    component={withNewDesignStyles(Layout)}
    onEnter={hooks.requireBrandAccessToMemberships(store)}
  >
    <IndexRoute
      components={{ title: () => <span>{t('memberships:navigation.memberships')}</span>, children: Memberships }}
    />
    <Route
      path="subscriptions"
      components={{
        title: () => <span>{t('memberships:navigation.subscriptions')}</span>,
        children: SubscriptionsList,
      }}
    />
    <Route
      path="invoices"
      components={{ title: () => <span>{t('memberships:navigation.invoices')}</span>, children: InvoicesList }}
    />
    <Route
      path="add"
      components={{
        title: () => <span>{t('memberships:navigation.memberships')}</span>,
        heading: () => <span>{t('memberships:navigation.add_membership')}</span>,
        headerButtons: () => <ExternalBrandMembershipsHeader />,
        children: ExternalBrandMemberships,
        hideNavigation: true,
      }}
    />
    <Route
      path=":id/edit"
      components={{
        title: () => <span>{t('memberships:navigation.memberships')}</span>,
        heading: () => <span>{t('memberships:navigation.edit_membership')}</span>,
        headerButtons: () => <ExternalBrandMembershipsHeader />,
        children: ExternalBrandMemberships,
        hideNavigation: true,
      }}
    />
    <Route
      path=":id/view"
      components={{
        title: () => <span>{t('memberships:navigation.membership_details')}</span>,
        children: MembershipShops,
      }}
    />
    <Route
      path="import"
      components={{
        title: () => <span>{t('memberships:navigation.memberships')}</span>,
        heading: () => <span>{t('memberships:navigation.import_member_subscriptions')}</span>,
        children: ImportSubscriptions,
      }}
    />
  </Route>
);

export default {
  ShopRoutes,
  BrandRoutes,
};
